module.exports = __webpack_public_path__ + "static/parade-2020-house31-d34cbe2f2af65e1bba8ae2870db9fdd6.jpg";